import { BodyText, Gutter, Headline, Link } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import { NewTabLinkAdapter } from '@cdaas/reusable-components-daas';

const MinBedriftHelp = () => {
  const { t } = useTranslation('minBedrift');

  return (
    <>
      <Gutter size="xlg" />
      <Headline size="lg" color="black" tagName="h1">
        {t('help.title')}
      </Headline>
      <Gutter size="sm" />
      <BodyText>{t('help.descriptionBodyText')}</BodyText>
      <Gutter size="sm" />
      <BodyText>{t('help.descriptionAddendum')}</BodyText>
      <Gutter size="xlg" />
      <Headline size="md" color="black" tagName="h2">
        {t('help.instructionsHeading')}
      </Headline>
      <Gutter size="sm" />
      <BodyText>{t('help.accessBodyText')}</BodyText>
      <Gutter size="sm" />
      <Link linkAdapter={NewTabLinkAdapter} to={process.env.REACT_APP_MIN_BEDRIFT_HELP_URI}>
        {t('help.minBedriftLinkText')}
      </Link>
    </>
  );
};

export default MinBedriftHelp;
